import React           from 'react'; 
import landscape       from './what_is_BSB.module.css';
import portrait        from './portrait.module.css';
import Newspaper       from '../components/Newspaper_3_col.jsx';
import {Context}       from '../services/context.js'
import Paper           from '../components/Paper.jsx';
import { Helmet }      from 'react-helmet';
import cx              from 'classnames';



const cx_title  = cx({[portrait.title]:  Context.portrait, [landscape.title]:   !Context.portrait});
const cx_header = cx({[portrait.header]: Context.portrait, [landscape.header]:  !Context.portrait});
const cx_text   = cx({[portrait.text]:   Context.portrait, [landscape.text]:    !Context.portrait});
const cx_ul     = cx({[portrait.ul]:     Context.portrait, [landscape.ul]:      !Context.portrait});
const cx_li     = cx({[portrait.li]:     Context.portrait, [landscape.li]:      !Context.portrait});

const text_1 = [
  {
    header: (
      <p className={cx_header}>
        Back‑Step Blockchain Explained
      </p>
    )
  },
  {
    text: (
      <p className={cx_text}>
        Back‑Step Blockchain is built on Georg Krause’s pioneering 2018 invention, just before the COVID‑19 pandemic paused many activities. 
        By fundamentally rethinking block processing, this technology delivers significant advantages to blockchain applications. 
        As blockchains underpin everything from cryptocurrencies to decentralized systems, Back‑Step Blockchain dramatically enhances 
        performance and opens the door to thousands of applications that traditional chains can’t support. 
        Unlike conventional chains—which are often expensive, slow, and scatter data globally—our approach offers superior efficiency and scalability.
      </p>
    )
  },
  {
    text: (
      <p className={cx_text}>
        This innovative cryptographic design enables speeds of up to millions of blocks per second—processing genuine blocks, not just transactions. 
        It can even be implemented on a single chip, such as one in a passport, with very low power per block. 
        Operating autonomously without a large node network, Back‑Step Blockchain lays the foundation for a new generation of applications. 
        Moreover, it can host other blockchains’ blocks within its payload—akin to virtual machines—where a parent chain ensures immutability 
        and child chains use fast, simple hashes. With a hardware‑based core that outperforms software‑only solutions, 
        Back‑Step Blockchain is engineered for resilience. We recommend deploying 3–5 systems in different locations to safeguard against 
        hardware failures or disasters, and regular backups will ensure your data is never lost.
      </p>
    )
  },
  {
    header: (
      <p className={cx_header}>
        How Long Can Blocks Be?
      </p>
    )
  },
  {
    text: (
      <p className={cx_text}>
        Back‑Step Blockchain supports variable‑length blocks from 16 bytes up to 100 MB. All data is stored on‑chain—no side‑car files—so each block can differ in size. 
        This flexibility makes it perfect for storing large documents, program code, photos, videos, AI prompts, NFTs, and more.
      </p>
    )
  },
  {
    header: (
      <p className={cx_header}>
        Do We Need Networks?
      </p>
    )
  },
  {
    text: (
      <p className={cx_text}>
        Yes and no. For applications where Back‑Step Blockchain is integrated into an ID card or a passport, only a local interface—often wireless—is needed. 
        For server‑based deployments, run Back‑Step Blockchain in a redundant setup with three or five connected units; high‑speed links are preferable. 
        Some customers may want chains per country, region, or city. Of course, if block input comes from a local network or the internet, a network connection is required. 
        However, there’s no need for huge clusters with thousands of nodes as in traditional blockchains.
      </p>
    )
  }
];

const text_2 = [
  {
    header: (
      <p className={cx_header}>
        Your First Back‑Step Blockchain: Trust.it
      </p>
    )
  },
  {
    text: (
      <p className={cx_text}>
        You’re invited to try Trust.it—a Back‑Step Blockchain application at <a href="https://trust-it.app">trust-it.app</a>. 
        Trust.it is currently a desktop‑only web app for private, commercial, and public use; a mobile version is coming soon.
      </p>
    )
  },
  {
    text: (
      <p className={cx_text}>
        Using Trust.it is free—you pay only a minimal fee when you store blocks. You can encrypt blocks (where permitted). 
        Add your own blocks to the chain and they remain there forever with no recurring payments. 
        No cryptocurrency is needed—no Ether, satoshis, cheques, or wallets. The system charges only for what you use—no subscriptions—and 
        new users receive an initial credit upon registration.
      </p>
    )
  },
  {
    text: (
      <p className={cx_text}>
        Each block can hold 16 bytes to 10 MB of data. The UI is currently in English, and all text payloads are UTF‑8 encoded. 
        Support for additional languages will follow. Any content over ~1,000 characters can be loaded from a file as “large data,” 
        which may include bytecode, images, videos, documents, NFTs, program code, and more.
      </p>
    )
  },
  {
    text: (
      <p className={cx_text}>
        Please note that the chain is in beta and may occasionally pause briefly for new feature rollouts. 
        We back up the chain daily—or automatically after every 10,000 new blocks—and you can download your own copy. 
        Trust.it’s Back‑Step Blockchain was initially designed with 100 TB of capacity, and we’ll continuously enhance both functionality and storage.
      </p>
    )
  },
  {
    text: (
      <p className={cx_text}>
        The chain runs on a robust server system and will shift to a 3‑of‑5 redundancy configuration after testing. 
        All data you store—even during tests—remains on the chain for at least 100 years; nothing can be erased. 
        Sensitive data can be encrypted subject to your jurisdiction’s regulations.
      </p>
    )
  },
  {
    text: (
      <p className={cx_text}>
        Users must register to write blocks, though identities stay anonymous. Thanks to low power consumption and high speed, our costs are very low. 
        We currently charge 2 units per block (≈ 2 US cents or 1.4 Chinese jiao). Reading the chain is free for everyone. 
        A privacy mode strongly encrypts all data—see “How It Works” for details.
      </p>
    )
  },
  {
    text: (
      <p className={cx_text}>
        Trust.it is for public, private, and commercial organizations—but it’s <em>not</em> a digital currency. 
        Instead, it serves as your personal electronic vault, event logbook, supply chain verifier, black‑box recorder, exchange platform—and more. 
        If you plan to deploy your own Back‑Step Blockchain, Trust.it is the ideal test case and source of ideas.
      </p>
    )
  }
];

    
    export class What_is_BSB extends React.Component  
    { 

        //------------------------------------------------------------------
        //  Constructor
        //------------------------------------------------------------------
        constructor(props) 
        {
          super(props);
          this.component= "";
          this.state = {content_disabled: false}
        }  
        
        componentDidMount()
        {
          //console.log('Component did mount in About Us');
          //this.forceUpdate()
          window.scrollTo({top:0, left: 0, behavious: 'smooth'})
        }
       
        //------------------------------------------------------------------
        //
        //------------------------------------------------------------------
        changeVisible(mode)
        {
          this.setState({content_disabled:mode})
        }

        //-------------------------------------------------------------------------
        //  For Portrait
        //-------------------------------------------------------------------------   
        render()
        { 
          if (Context.portrait)
          {
            this.component = 
            <div className={portrait.backdrop}>

                <Helmet>
                <title>What is Back-Step Blockchain</title>
                <meta name="description" content="Explains what this new invention is all about and their hge advantages." />
                <meta charset="utf-8" />
                </Helmet>

                <div className={cx_title}>
                  Back-Step Blockchain is...
                </div>

                <div> 
                  < Paper textLines = {text_1}/> 
                </div>
  
                <div>
                  <Paper  textLines = {text_2}/>
                </div>
            </div>
          }    
          else
          //-------------------------------------------------------------------------
          //  For Lanscape
          //-------------------------------------------------------------------------   
          {
            this.component = 
            <div className={landscape.backdrop} onMouseDown={()=>this.changeVisible(true)} onMouseUp={()=>this.changeVisible(false)} onContextMenu={(e) => e.preventDefault()}>

                <Helmet>
                  <title>What is Back-Step Blockchain</title>
                  <meta name="description" content="Explains what this new invention is all about and their hge advantages." />
                  <meta charset="utf-8" />
                </Helmet>
      
                {! this.state.content_disabled &&
                  <>
                    <div className={landscape.title_location}>
                      <div className={landscape.title_text}>
                        <p>Back-Step Blockchain is...</p>
                      </div>
                    </div>

                    <div className={landscape.container_2_5_2}>

                    <div className={landscape.grid_item}> 
                    < Newspaper textLines = {text_1}/> 
                    </div>
      
                    <div className={landscape.grid_item}>
                      <Newspaper  textLines = {text_2}/>
                    </div>
       
                  </div>
                  </>
                }
              </div>
          }
          return this.component ;
        }
    }
    
    
    